import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
    ANNOTATION_MODAL_SIZE,
} from './GlobalConstants';
import * as THREE from "three";
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
// export const ENQUIRE_EMAIL = 'ENQUIRE';
export const ENQUIRE_EMAIL = 'Send Your Submission';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/eccb%2Feccb-2023%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";

const INFO_TAG = '/assets/sprites/project_sprites/Info.svg';


const AnnotationsDB = [

    /* Audio */
    // {
    //     paintingId: 'VENGLA_A052_I',
    //     videoId: 'VENGLA_A052_I',
    //     standaloneVideoElementId: 'VENGLA_A052_I',
    //     videoURL: 'VENGLA_A052_I.mp3',
    //     displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    //     headerText: '',
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     useVideoMeshButton: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
    //     displayAudioSprite: 'N',
    //     videoLoop: false,
    //     videoAutoPlayDelay: 0,
    //     // videoButtonScale: {x:.05,y:.05,z:1},
    //     // video_button_z_offset: .01,
    //     // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
    //     // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
    //     // videoLoop: true,
    // },
    /* Audio */

    /* Videos */
    {
        paintingId: 'INT_INT_V002',
        videoId: 'INT_INT_V002',
        standaloneVideoElementId: 'INT_INT_V002',
        videoURL: 'INT_INT_V002.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>Historical Reel</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'INT_INT_V003',
        videoId: 'INT_INT_V003',
        standaloneVideoElementId: 'INT_INT_V003',
        videoURL: 'INT_INT_V003.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        // headerText: '<h6>ECCB Song</h6>',
        headerText: '<h6>ECCB 40th Anniversary Song</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'LAF_LAF_V206',
        videoId: 'LAF_LAF_V206',
        standaloneVideoElementId: 'LAF_LAF_V206',
        videoURL: 'LAF_LAF_V206.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>The first episode of ECCB Connects<br>April 6, 2016</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'LAF_LAF_V207',
        videoId: 'LAF_LAF_V207',
        standaloneVideoElementId: 'LAF_LAF_V207',
        videoURL: 'LAF_LAF_V207.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>Launch of the ECCB Polymer Notes<br>May 29, 2019</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'LAF_LAF_V208',
        videoId: 'LAF_LAF_V208',
        standaloneVideoElementId: 'LAF_LAF_V208',
        videoURL: 'LAF_LAF_V208.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>Announcement of the DCash Launch Date<br>Video Premiere: March 16, 2021</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'LAF_LAF_V209',
        videoId: 'LAF_LAF_V209',
        standaloneVideoElementId: 'LAF_LAF_V209',
        videoURL: 'LAF_LAF_V209.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>ECCB Going Green<br>Video Premiere: September 18, 2019</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },

    {
        paintingId: 'TBP_TBP_V237',
        videoId: 'TBP_TBP_V237',
        standaloneVideoElementId: 'TBP_TBP_V237',
        videoURL: 'TBP_TBP_V237.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `Governor Antoine explains The Big Push at the launch of the ECCB's 40th Anniversary Celebrationson January 19th, 2023.`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },

    {
        paintingId: 'DVE_DVE_V258',
        videoId: 'DVE_DVE_V258',
        standaloneVideoElementId: 'DVE_DVE_V258',
        videoURL: 'DVE_DVE_V258.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `ECCB Connects – Season 3: Episode 1 – Tribute to Hon. Sir K. Dwight Venner<br>(Publication date January 4, 2017)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        annotation_location_horiz_offset: 0.2,
        // annotationScale: 0.2,
    },
    {
        paintingId: 'DVE_DVE_V259',
        videoId: 'DVE_DVE_V259',
        standaloneVideoElementId: 'DVE_DVE_V259',
        videoURL: 'DVE_DVE_V259.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `ECCB Connects Season 3 Episode 2 – Tributes from Sir Dwight’s Funeral Service<br>(Publication date January 11, 2017)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        // annotationScale: 0.01,
    },
    {
        paintingId: 'DVE_DVE_V260',
        videoId: 'DVE_DVE_V260',
        standaloneVideoElementId: 'DVE_DVE_V260',
        videoURL: 'DVE_DVE_V260.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `Eulogy of Hon. Sir K. Dwight Venner<br>(Publication Date January 13, 2017)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'DVE_DVE_V261',
        videoId: 'DVE_DVE_V261',
        standaloneVideoElementId: 'DVE_DVE_V261',
        videoURL: 'DVE_DVE_V261.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `Unveiling of the Hon. Sir K. Dwight Venner Building Signage<br>(Publication Date March 3, 2017)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'DVE_DVE_V262',
        videoId: 'DVE_DVE_V262',
        standaloneVideoElementId: 'DVE_DVE_V262',
        videoURL: 'DVE_DVE_V262.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `ECCB Connects Season 3 Episode 10 – Naming of Hon. Sir K. Dwight Venner Building<br>(Publication date March 9, 2017)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    {
        paintingId: 'DVE_DVE_V275',
        videoId: 'DVE_DVE_V275',
        standaloneVideoElementId: 'DVE_DVE_V275',
        videoURL: 'DVE_DVE_V275.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `Launch of the ECCB Polymer Notes<br>May 29, 2019`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },

    {
        paintingId: 'TAN_TAN_V316',
        videoId: 'TAN_TAN_V316',
        standaloneVideoElementId: 'TAN_TAN_V316',
        videoURL: 'TAN_TAN_V316.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: '<h6>As at March 31st</h6>',
        bodyText: ``,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        // annotation_location_horiz_offset: 0.2,
    },
    // {
    //     paintingId: "GEN_GEN_P345",
    //     videoId: 'GEN_GEN_P345',
    //     standaloneVideoElementId: 'GEN_GEN_P345',
    //     videoURL: 'GEN_GEN_P345.mp4',
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P345.jpg/info.json`,
    //     displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
    //     headerText: '<h6>Sir Arthur: The First</h6>',
    //     bodyText: `Click the link below to learn about 25th Sir Arthur Lewis Memorial Lecture`,
    //     displayMesh: 'Y',
    //     redisplayMeshAfterVideoEnd: 'Y',
    //     displayHeight: 90,
    //     // videoTextureEncoding: THREE.sRGBEncoding,
    //     videoAutoPlay: 'N',
    //     useVideoMeshButton: 'Y',
    //     // spriteImageURL: INFO_TAG,
    //     annotationScale: new THREE.Vector3(0.18, 0.18, 1),
    //     annotation_location_z_offset: 0.08,
    //     urlLink1Label: "25th Memorial Lecture",
    //     urlLink1: "https://www.youtube.com/watch?v=BfRlztkGd2M",
    // },
    {
        paintingId: 'TAN_TAN_V332',
        videoId: 'TAN_TAN_V332',
        standaloneVideoElementId: 'TAN_TAN_V332',
        videoURL: 'TAN_TAN_V332.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6></h6>',
        bodyText: `Newly appointed Governor of the Eastern Caribbean Central Bank, Timothy N.J. Antoine, engages the ECCU media on his first day in office on February 1st, 2016.  Inside ECCB, the podcast that Governor Antoine references in the video, was launched as ECCB Connects on April 6th, 2016.`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        annotation_location: ANNOTATION_LOCATION.CENTER_RIGHT,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['TAN_TAN_P333_01', 'TAN_TAN_P333_00', 'TAN_TAN_P333_06', 'TAN_TAN_P333_02', 'TAN_TAN_P333_03',
            'TAN_TAN_P333_04', 'TAN_TAN_P333_05'],
    },
    {
        paintingId: "TAN_TAN_P333_00",
        videoId: 'TAN_TAN_V332',
        standaloneVideoElementId: 'TAN_TAN_V332',
        videoURL: 'TAN_TAN_V332.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Newly appointed Governor of the Eastern Caribbean Central Bank, Timothy N.J. Antoine, engages the ECCU media on his first day in office on February 1st, 2016.  Inside ECCB, the podcast that Governor Antoine references in the video, was launched as ECCB Connects on April 6th, 2016.`,
    },
    {
        paintingId: "TAN_TAN_P333_01",
        iframeSource: 'https://www.youtube-nocookie.com/embed/umTHq8DhHjQ',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>The Honourable Victor F. Banks, Chairman of the Eastern Caribbean Central Bank (ECCB) Monetary Council introduces the new Governor of the ECCB, Mr. Timothy N.J. Antoine, to the ECCU media on February 1st, 2016.`,
    },
    {
        paintingId: "TAN_TAN_P333_02",
        iframeSource: 'https://www.youtube-nocookie.com/embed/-ILdOVLBrdc?si=EoW0mGAc_anyNSlq',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Governor Antoine met with his staff and well-wishers virtually on February 1st, 2021 to start his second five-year term with prayers and thanksgiving.`,
    },
    {
        paintingId: "TAN_TAN_P333_03",
        iframeSource: 'https://www.youtube-nocookie.com/embed/8Nov9UWuSF4',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Governor Timothy N.J. Antoine's Remarks at Launch of ECCB's 40th Anniversary Celebrations on January 19th, 2023`,
    },
    {
        paintingId: "TAN_TAN_P333_04",
        iframeSource: 'https://www.youtube-nocookie.com/embed/giNk7rZ8hOs',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Governor of the ECCB, Timothy N.J. Antoine addresses congregation at the Antioch Baptist Church, St. Kitts and Nevis, in celebration of the Bank's 40th Anniversary on October 1st, 2023.`,
    },
    {
        paintingId: "TAN_TAN_P333_05",
        iframeSource: 'https://www.youtube-nocookie.com/embed/oswXwwtEV90?si=wR-ms_pm7Llvvy1F',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Governor Antoine appears as the Guest on the St. Kitts and Nevis Information Service’s InFocus programme to discuss the ECCB at 40.`,
    },
    {
        paintingId: "TAN_TAN_P333_06",
        videoId: 'LAF_LAF_V206',
        standaloneVideoElementId: 'LAF_LAF_V206',
        videoURL: 'LAF_LAF_V206.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>Newly appointed Governor of the Eastern Caribbean Central Bank, Timothy N.J. Antoine is interviewed on the very first episode of ECCB Connects, which was published online on April 6th, 2016.`,
    },

    /* Cineplex Videos */
    {
        // This is a Cineplex video now
        paintingId: 'INT_INT_V150',
        videoId: 'INT_INT_V150',
        standaloneVideoElementId: 'INT_INT_V150',
        videoURL: 'INT_INT_V150.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>ECCB@40 Employees’ Anniversary Video</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        annotationScale: new THREE.Vector3(0.18, 0.18, 1),
        annotation_location_z_offset: 0.08,
    },

    {
        paintingId: 'GEN_GEN_V213',
        videoId: 'GEN_GEN_V213',
        standaloneVideoElementId: 'GEN_GEN_V213',
        videoURL: 'GEN_GEN_V213.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>Next Generation</h6>',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        annotationScale: new THREE.Vector3(0.18, 0.18, 1),
        annotation_location_z_offset: 0.08,
    },
    {
        paintingId: 'GEN_GEN_V346',
        videoId: 'GEN_GEN_V346',
        standaloneVideoElementId: 'GEN_GEN_V346',
        videoURL: 'GEN_GEN_V346.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '<h6>Sir Arthur: The First</h6>',
        bodyText: `Click the link below to watch the 25th Sir Arthur Lewis Memorial Lecture`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
        annotationScale: new THREE.Vector3(0.18, 0.18, 1),
        annotation_location_z_offset: 0.08,
        annotation_location_vert_offset: 0.16,
        annotation_location_horiz_offset: 0.16,
        urlLink1Label: "25th Memorial Lecture",
        // urlLink1: "https://www.youtube.com/watch?v=BfRlztkGd2M",
        urlLink1: "https://vimeo.com/896206894/8058ba513c?share=copy",
    },
    /* Cineplex Videos */
    /* Videos */

    /* Audio */
    {
        paintingId: 'DVE_DVE_A263',
        videoId: 'DVE_DVE_A263',
        standaloneVideoElementId: 'DVE_DVE_A263',
        videoURL: 'DVE_DVE_A263.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'DVE_DVE_A264',
        videoId: 'DVE_DVE_A264',
        standaloneVideoElementId: 'DVE_DVE_A264',
        videoURL: 'DVE_DVE_A264.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'DVE_DVE_A265',
        videoId: 'DVE_DVE_A265',
        standaloneVideoElementId: 'DVE_DVE_A265',
        videoURL: 'DVE_DVE_A265.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'DVE_DVE_A266',
        videoId: 'DVE_DVE_A266',
        standaloneVideoElementId: 'DVE_DVE_A266',
        videoURL: 'DVE_DVE_A266.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'DVE_DVE_A267',
        videoId: 'DVE_DVE_A267',
        standaloneVideoElementId: 'DVE_DVE_A267',
        videoURL: 'DVE_DVE_A267.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    /* Audio */

    /* Text Annotations */
    // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    // urlLink1Label: "Silk Road Virtual Museum",
    // urlLink1: "https://silkroadvirtualmuseum.com/landing/",
    // annotation_location_vert_offset: -0.48,
    // annotation_location_horiz_offset: -0.08,
    {
        paintingId: "MSK_MSK_P005",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_01_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_02_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_03_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_04_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_05_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_06_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_07_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_08_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_09_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_10_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MSK_MSK_P005_11_V02.jpg/info.json`],
        headerText: `<h6>ECCA Moves to St. Kitts after Barbados Withdraws</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    // {
    //     paintingId: "EST_EST_P151",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}EST_EST_P151.jpg/info.json`,
    //     headerText: `<h6>Establishment of the ECCB</h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },
    {
        paintingId: "EST_EST_P152",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EST_EST_P152.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P151.jpg/info.json`],
        headerText: `<h6>Establishment of the ECCB</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "EST_EST_P007_01",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EST_EST_P007_01_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P007_02_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P151.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P152.jpg/info.json`],
        headerText: `<h6>Establishment of the ECCB</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    {
        paintingId: "EXP_EXP_P009",
        videoId: "",
        videoURL: "",
        displayMesh: "Y",
        useMeshButton: "N",
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['EXP_EXP_P009_01', 'EXP_EXP_P009_02'],
    },
    {
        paintingId: "EXP_EXP_P009_01",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_13_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_14_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_15_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_16_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_17_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_18_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_19_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_20_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_02_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_04_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_05.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_06.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_07.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_08_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_00.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_01_V03.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_11_V02_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_01_V02_01.jpg/info.json`,


            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_09_V03.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_11_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_12_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_21_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_22_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P009_23_V02.jpg/info.json`,],
        headerText: `<h6>Expansion of the ECCB</h6>`,
        bodyText: `Click on the yellow arrow to view the ECCB 2022-2023 Annual Report`,
    },
    {
        paintingId: "EXP_EXP_P009_02",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P163.jpg/info.json`,
        headerText: `<h6>ECCB 2022-2023 Annual Report</h6>`,
        bodyText: `Click on the yellow arrow to read articles about the Expansion of the ECCB`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/EXP_EXP_P163.pdf',
    },
    {
        paintingId: "EXP_EXP_P268",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P216_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P216_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EXP_EXP_P216_03.jpg/info.json`,],
        headerText: `<h6></h6>`,
        // bodyText: `Click on the yellow arrow to view the ECCB 2022-2023 Annual Report or to read articles about the Expansion of the ECCB<br><br><b>Click on the white arrow to view a slideshow of images</b><br><br><b>Image #1</b><br>ECCB Governor Sir K. Dwight Venner is pictured at right during the blessing of the new ECCB building on October 29th, 1994.<br><br><b>Image #2</b><br>Prime Minister of The Commonwealth of Dominica, Dame Eugenia Charles cuts the ribbon, declaring the new ECCB Headquarters officially open on Saturday, October 29th, 1994.<br><br><b>Image #3</b><br>ECCB Governor Sir K. Dwight Venner is pictured at far left with other officials at the ground breaking ceremony for the new ECCB Headquarters building on Saturday, November 21st, 1992.`,
        bodyText: `<b>Click on the white arrow to view a slideshow of photos related to the Expansion of the ECCB. Scroll down to read the accompanying information</b><br><br><b>Image #1</b><br>ECCB Governor Sir K. Dwight Venner is pictured at right during the blessing of the new ECCB building on October 29th, 1994.<br><br><b>Image #2</b><br>Prime Minister of The Commonwealth of Dominica, Dame Eugenia Charles cuts the ribbon, declaring the new ECCB Headquarters officially open on Saturday, October 29th, 1994.<br><br><b>Image #3</b><br>ECCB Governor Sir K. Dwight Venner is pictured at far left with other officials at the ground breaking ceremony for the new ECCB Headquarters building on Saturday, November 21st, 1992.`,
        displayMesh: "N",
        useMeshButton: "N",
    },

    {
        paintingId: "SCJ_SCJ_P148",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P148.jpg/info.json`,
        headerText: `<h6>Sir Cecil Jacobs,<br>First Governor of the ECCB</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "SCJ_SCJ_P011",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_01_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_02_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_03_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_04_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_05_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SCJ_SCJ_P011_06_V02.jpg/info.json`],
        headerText: `<h6>Sir Cecil Jacobs,<br>First Governor of the ECCB</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_10A_P016",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_10A_P014.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_10A_P015.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_10A_P016.jpg/info.json`],
        headerText: `<h6>10th Anniversary</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_BCC_P027",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P018_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P019.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P020_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P021_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P022_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P023_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P024_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P025.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P026_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P027_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P028_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_BCC_P029.jpg/info.json`],
        headerText: `<h6>BCCB Currency</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_50A_P033",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_50A_P031.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_50A_P032.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_50A_P033.jpg/info.json`],
        headerText: `<h6>Coin to commemorate the 50th Anniversary<br>of the University of the West Indies (UWI)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_CDB_P035",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_CDB_P035_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CDB_P036_V01.jpg/info.json`],
        headerText: `<h6>Coins to commemorate the inauguration<br>of the Caribbean Development Bank (CDB)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_CON_P040",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_CON_P038_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CON_P039_V01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_CON_P040_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CON_P041_V01.jpg/info.json`],
        headerText: `<h6>Counterfeit Notes<br>Early Communications</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_CUP_P045",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P043_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P044_V01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P045_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P046_V01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P046_01_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_CUP_P046_02_V01.jpg/info.json`
        ],
        headerText: `<h6>Currency Peg<BR>Early Days</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_DEM_P048",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CUR_DEM_P048.jpg/info.json`,
        headerText: `<h6>Demonetization</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_ECC_P056",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P050_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P051.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P052_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P053.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P054_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P055.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P056_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_ECC_P057.jpg/info.json`],
        headerText: `<h6>ECCA Currency</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_NRC_P063",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P059.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P060.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P061.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P062.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P063.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P064.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P065.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P066.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NRC_P067_V01.jpg/info.json`],
        headerText: `<h6>New Round Coins</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_NSC_P071",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P069_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P070.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P071.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P072.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P073.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P074_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P075.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P076.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P077.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P078.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P079.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P080.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P081_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSC_P082.jpg/info.json`],
        headerText: `<h6>New Series of Currency Notes<br>(1993)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_NSE_P084",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P084_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P085.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P086_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P087.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P088.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P089_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P090_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P091.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_NSE_P092.jpg/info.json`],
        headerText: `<h6>New Series of ECCA Notes<br>(1983)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_PJP_P094",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CUR_PJP_P094.jpg/info.json`,
        headerText: `<h6>Pope John Paul</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_QEV_P096",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CUR_QEV_P096.jpg/info.json`,
        headerText: `<h6>Queen’s Visit</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_U01_P106",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_U01_P098.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P099_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P100_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P102.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P103_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P104_V02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P105_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P106.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P107_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P108.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U01_P109_V01.jpg/info.json`],
        headerText: `<h6>Upgrade to Notes<br>(2001)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_U04_P115",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_U04_P111.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U04_P112.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U04_P113.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U04_P114.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U04_P115.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U04_P116.jpg/info.json`],
        headerText: `<h6>Upgrade to Notes<br>(2004)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_U94_P118",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_U94_P118.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U94_P119_V01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U94_P120_V01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_U94_P121.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_U94_P122.jpg/info.json`],
        headerText: `<h6>Upgrades to Notes<br>(1994)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    {
        paintingId: "CUR_CUR_P347",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_CUR_P347_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_CUR_P347_02.jpg/info.json`
            ],
        headerText: `<h6>ECCB's 40th Anniversary<br>Commemorative $2 Banknote</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of the 2$ Banknote</b><br><br>Please see below <b>link #1</b> to the promo video, which describes the ECCB's 40th Anniversary Commemorative $2 Banknote<br><br>Please see <b>link #2</b> to the Launch Ceremony for the ECCB's 40th Anniversary Commemorative $2 Banknote on Friday, December 1st, 2023<br><br>Please see <b>link #3</b> to the EC$2 Commemorative Banknote – Key Design Elements and Security Features`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Link #1",
        urlLink1: 'https://www.youtube.com/watch?v=aqIndsW5vjk',
        urlLink2Label: "Link #2",
        urlLink2: 'https://www.youtube.com/watch?v=iAgZeyPPjzY&t=3917s',
        urlLink3Label: "Link #3",
        urlLink3: 'https://www.youtube.com/watch?v=R7lxiAfjiWc',
        // hasCarouselAsParent: 'Y',
        // carouselAnnotationSiblings: ['CUR_CUR_P347_01', 'CUR_CUR_P347_02', 'CUR_CUR_P347_03'],
    },
    // {
    //     paintingId: "CUR_CUR_P347_01",
    //     iframeSource: 'https://www.youtube-nocookie.com/embed/aqIndsW5vjk',
    //     videoId: "",
    //     videoURL: "",
    //     headerText: `<h6>EC$2 Commemorative Bank Note</h6>`,
    //     bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>`,
    // },
    // {
    //     paintingId: "CUR_CUR_P347_02",
    //     iframeSource: 'https://www.youtube-nocookie.com/embed/iAgZeyPPjzY?si=Rqf4ZoIbxaJeo5Vv',
    //     videoId: "",
    //     videoURL: "",
    //     headerText: `<h6>Launch of EC$2 Commemorative Banknote</h6>`,
    //     bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>`,
    // },
    // {
    //     paintingId: "CUR_CUR_P347_03",
    //     iframeSource: 'https://www.youtube-nocookie.com/embed/R7lxiAfjiWc',
    //     videoId: "",
    //     videoURL: "",
    //     headerText: `<h6>EC$2 Commemorative Banknote<br>Key Design Elements and Security Features</h6>`,
    //     bodyText: `<b>Click on yellow arrows to watch a selection of videos.</b><br><br>`,
    // },

    {
        paintingId: "LTI_LTI_P154",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P154_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P154_02.jpg/info.json`],
        headerText: `<h6>Andrea Charles-Browne</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P156",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P156_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P156_02.jpg/info.json`],
        headerText: `<h6>Dulcie Richardson</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P157",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P157_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P169.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P157_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P157_03.jpg/info.json`],
        headerText: `<h6>Dulcie Richardson</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P158",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P158_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P158_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P158_03.jpg/info.json`],
        headerText: `<h6>William Archibald Kelsick</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P159",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P159_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P159_02.jpg/info.json`],
        headerText: `<h6>William Archibald Kelsick</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P160",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P160_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P160_02.jpg/info.json`],
        headerText: `<h6>William Archibald Kelsick</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "LTI_LTI_P161",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P161_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P161_02.jpg/info.json`],
        headerText: `<h6>Jennifer Nero</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_84N_P126",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_84N_P126_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_84N_P126_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_84N_P126_03.jpg/info.json`],
        headerText: `<h6>1984: The First Bank Note to Bear the Title of the ECCB</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_25A_P130",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_25A_P130.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_25A_P131.jpg/info.json`],
        headerText: `<h6>2008: 25th Anniversary Coin: <br>"Together We Stand"</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        // `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P135.jpg/info.json`,`${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P136.jpg/info.json`
        paintingId: "CUR_2DC_P133",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P133.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P134.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P137.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P138.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P139.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_2DC_P140.jpg/info.json`
        ],
        headerText: `<h6>2011: Two-Dollar Coin to Celebrate 10 Years of<br>Financial Information Month (FIM)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "CUR_OEC_P142",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_OEC_P142.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_OEC_P143.jpg/info.json`
        ],
        headerText: `<h6>2011: Eight-Dollar Coin <br>Commemorating the Establishment<br> of the OECS Economic Union</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        annotation_location: ANNOTATION_LOCATION.TOP_LEFT,
    },
    {
        paintingId: "CUR_32A_P145",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CUR_32A_P145.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}CUR_32A_P146.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CUR_32A_P147.jpg/info.json`
        ],
        headerText: `<h6>2015: 32nd Anniversary Commemorative <br>One-Dollar Coin</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        annotation_location: ANNOTATION_LOCATION.TOP_LEFT,
    },

    {
        paintingId: "LTI_LTI_P155",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LTI_LTI_P155.jpg/info.json`,
        headerText: `<h6>Jean Thomas</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    {
        paintingId: "LTI_LTI_P165",
        videoId: "",
        videoURL: "",
        isMediaUsed: 'N',
        headerText: `<h6>Lives and Times of...</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // urlLink1Label: "Download Report",
        // urlLink1: '/pdf/EXP_EXP_P163.pdf',
        emailSubjectText: 'Enquiry about Lives and Times',
        // ContactURL: 'efapc@eccb-centralbank.org',
        EnquireEmail: 'efapc@eccb-centralbank.org',
    },
    {
        paintingId: "GEN_GEN_T162",
        videoId: "",
        videoURL: "",
        // isMediaUsed:'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_T162.jpg/info.json`,
        headerText: `<h6>Sir Arthur Lewis Memorial Lecture</h6>`,
        bodyText: `To learn more about Sir Arthur Lewis's life, watch "Sir Arthur:  The First" in the ECCB@40 Cineplex.<br><br><b>Biography</b><br>Sir William Arthur Lewis was a national of Saint Lucia whose parents were from Antigua and Barbuda.  Born in Saint Lucia on January 23rd, 1915, he would go on to win the Island Scholarship as a teenager.<br><br>From 1934 to 1937, Arthur Lewis was a student at the London School of Economics and Political Science, from which he graduated with first class honours.  After receiving a scholarship from the London School of Economics to do a Ph.D. in Industrial Economics, he served as a member of its staff from 1938 to 1948.  Sir Arthur Lewis married Gladys, a Grenadian, in 1947, with whom he had two daughters, Elizabeth and Barbara.  In 1948, at the age of 33, he was made a full professor at the University of Manchester.<br><br>During his highly acclaimed career, Sir Arthur Lewis also served as UN Economic Adviser to the Prime Minister of Ghana; Deputy Managing Director of the UN Special Fund; and Vice-Chancellor (= President) of the University of the West Indies.  He set up the Caribbean Development Bank (CDB), which was established by an agreement signed in 1969, and served as the CDB’s first President from 1970 to 1973.  In 1979, he was awarded the prestigious Nobel Prize in Economic Sciences for innovative economic development research focusing on developing countries.  Sir Arthur Lewis served on Princeton University’s faculty for 20 years up until 1983 and was the University’s first black full professor.<br><br>He died in Barbados on June 15th, 1991 at the age of 76.<br><br>On November 14th, 1996, the Eastern Caribbean Central Bank held the inaugural Annual Sir Arthur Lewis Memorial Lecture to honour the memory of the Nobel Laureate in Economics.  Sir Arthur Lewis’ image appears on the hundred dollar note of the EC currency.`,
        displayMesh: "N",
        useMeshButton: "Y",
        urlLink1Label: "Website",
        urlLink1: 'https://www.eccb-centralbank.org/sir-arthur-lewis-memorial-lecture-1',
        urlLink2Label: "25th Memorial Lecture",
        // urlLink2: 'https://www.youtube.com/watch?v=BfRlztkGd2M',
        urlLink2: 'https://vimeo.com/896206894/8058ba513c?share=copy',
        spriteImageURL: INFO_TAG,
        annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "GEN_GEN_P166",
        videoId: "",
        videoURL: "",
        isMediaUsed: 'N',
        headerText: `<h6><b>Acknowledgemnets</b></h6>`,
        // bodyText: `A great deal of work has gone into creating the ECCB’s 40th Anniversary Virtual Museum, and we take this opportunity to acknowledge and express gratitude to the following:<br>V21 Artspace for building and designing the virtual museum<br><br><b>Contributions from the ECCB:</b><br>Valencia Grant, Virtual Museum Research Lead and Curator<br>Marvin Jones, Virtual Museum Technical Lead and Design Liaison<br>Other Members of the ECCB’s 40th Anniversary Planning Committee and Secretariat:<br>Chairperson, Dr. Valda F. Henry (Deputy Governor of the ECCB)<br>Leon Bullen<br>Beverley Edwards-Gumbs<br>Kereem Ferrol<br>Marie-Louise Francis<br>Vanessa Francis-Pennyfeather<br>Benedict John<br>Ashanda Lapsey<br>Adaeze Matthew-Hanley<br>Everton Sealy<br>Jehu Sedra<br>Gillian Skerritt<br>Cosilia St. Louis-Jeremiah<br><br><b>Special thanks to:</b><br>ECCB Governor, Timothy N.J. Antoine<br>Chief Director (Policy), D. Tracy Polius<br>Acting Director of the Corporate Relations Department (CRD), Shermalon Kirby<br>CRD Officers (in particular Marlon Bristol, Shana Derrick and Brentwood Drigo)<br>Director of the Currency Management Department, Rosbert Humphrey<br>Acting Director of the Human Resources Department, Merva Mallalieu<br>ECCB Library Staff: Carmen Blanchard-Browne and Shaundel Jones<br>Senior Project Specialist, Sybil Welsh<br>Members of the Marketing, Communications and Public Relations (MCPR) Subcommittee of the 40th Anniversary Planning Committee (not already acknowledged above):<br>Aurin Heyliger<br>Nevine Harvey<br>Sheena Gonsalves<br>Steven Neckles<br>ECCB Employees and Retirees who participated in our special 40th Anniversary video productions (to be posted over the course of several months)<br><br><b>Other Contributions:</b><br>Research assistance provided by the following external partners:<br>Assistant Archivist at the St. Kitts & Nevis National Archives, Mavis Johnson-Vaughan<br>Other Employees of the National Archives at Government Headquarters: Ranetta Browne-Belle,<br>Shaylyn Gibson and Kyle Maynard<br>Staff at The Charles A. Halbert Public Library<br>Editor of The Labour Spokesman, Precious Mills<br>Production and videography assistance provided by the following external partner:<br>Cleon Bradshaw<br>Three-dimensional bust of Nobel Laureate Sir Arthur Lewis made by Oyehmi T. Begho of Evolution Media Lab<br><br><b>Primary Sources:</b><br>Eastern Caribbean Central Bank<br>The Democrat Newspaper<br>The Labour Spokesman Newspaper<br>The Grenada Informer<br>The Grenadian Voice<br>Archival photographs (to be posted) provided by Denzil (Don) James, Earl Smithen and Corinne Telfer-James`,
        bodyText: `A great deal of work has gone into creating the ECCB’s 40th Anniversary Virtual Museum, and we take this opportunity to acknowledge and express gratitude to the following:<br><i>V21 Artspace</i> for building and designing the virtual museum<br><br><b>Contributions from the ECCB:</b><br>Valencia Grant, Virtual Museum Research Lead and Curator<br>Marvin Jones, Virtual Museum Technical Lead and Design Liaison<br>Other Members of the ECCB’s 40th Anniversary Planning Committee and Secretariat:<br>Chairperson, Dr. Valda F. Henry (Deputy Governor of the ECCB)<br>Acklyn Blaize<br>Leon Bullen<br>Beverley Edwards-Gumbs<br>Kereem Ferrol<br>Lisa Francis<br>Marie-Louise Francis<br>Vanessa Francis-Pennyfeather<br>Benedict John<br>Ashanda Lapsey<br>Adaeze Matthew-Hanley<br>Everton Sealy<br>Jehu Sedra<br>Gillian Skerritt<br>Cosilia St. Louis-Jeremiah<br><br><b>Special thanks to:</b><br>ECCB Governor, Timothy N.J. Antoine<br>Chief Director (Policy), D. Tracy Polius<br>Director of the Corporate Relations Department (CRD), Shermalon Kirby<br>CRD Officers (in particular Marlon Bristol, Shana Derrick and Brentwood Drigo)<br>Director of the Currency Management Department, Rosbert Humphrey<br>Acting Director of the Human Resources Department, Merva Mallalieu<br>ECCB Library Staff: Carmen Blanchard-Browne and Shaundel Jones<br>Senior Project Specialist, Sybil Welsh<br>Policy Specialist, Patricia Welsh<br>ECCB Employees and Retirees who participated in our special 40th Anniversary video productions<br><br><b>Other Contributions:</b><br>Research assistance provided by the following external partners:<br>Assistant Archivist at the St. Kitts & Nevis National Archives, Mavis Johnson-Vaughan<br>Other Employees of the National Archives at Government Headquarters: Ranetta Browne-Belle, Shaylyn Gibson and Kyle Maynard<br>Staff at The Charles A. Halbert Public Library<br>Editor of The Labour Spokesman, Precious Mills<br>Production and videography assistance provided by the following external partner:<br>Cleon Bradshaw<br>Three-dimensional bust of Nobel Laureate Sir Arthur Lewis made by Oyehmi T. Begho of Evolution Media Lab<br><br><b>Primary Sources:</b><br>Eastern Caribbean Central Bank<br>The Democrat Newspaper<br>The Labour Spokesman Newspaper<br>The Grenada Informer<br>The Grenadian Voice<br>Archival photographs provided by Denzil (Don) James and Earl Smithen<br>Members of the Budget Subcommittee of the 40th Anniversary Planning Committee chaired by Adaeze Matthew-Hanley:<br>Nelisa Anthony<br>Sharon Tisson-Bennett<br>Micah Browne<br>Members of the Community Outreach Subcommittee of the 40th Anniversary Planning Committee co-chaired by Kereem Ferrol and Benedict John:<br>Nigel Browne<br>Lisa Francis<br>Marie-Louise Francis<br>Sheon John<br>Michael Morgan<br>Florence Palmer<br>Sasha Richards<br>Members of the Entertainment Subcommittee of the 40th Anniversary Planning Committee chaired by Cosilia St. Louis-Jeremiah:<br>Acklyn Blaize<br>Schwabach Caines<br>Shana Derrick<br>Leon Esprit<br>Kereem Ferrol<br>Heidi Hypolite<br>Merva Mallalieu<br>Marissa Richardson-Orchard<br>Laurel Seraphin-Bedford<br>Sybil Welsh<br>Jacob Wilson<br>Members of the Family Fun Day Subcommittee of the 40th Anniversary Planning Committee chaired by Beverley Edwards-Gumbs:<br>Livia Bertin-Mark<br>Acklyn Blaize<br>Emma Felix<br>Andrea Gilbert-Bullen<br>Darnell Morton<br>Gillian Skerritt<br>Elizabeth Wayland-Phillip<br>Members of the Gala Subcommittee of the 40th Anniversary Planning Committee chaired by Beverley Edwards-Gumbs:<br>Livia Bertin-Mark<br>Acklyn Blaize<br>Emma Felix<br>Andrea Gilbert-Bullen<br>Darnell Morton<br>Gillian Skerritt<br>Elizabeth Wayland-Phillip<br>Members of the Lecture Subcommittee of the 40th Anniversary Planning Committee chaired by Everton Sealy:<br>Angela Estwick<br>Linda Felix-Berkeley<br>Karel Forde-Harrigan<br>Kozel Fraser<br>Sherma John<br>Shirmaine Lynch-Harrigan<br>Members of the Logistics Subcommittee of the 40th Anniversary Planning Committee chaired by Ashanda Lapsey:<br>Seana Benjamin-Mack<br>Acklyn Blaize<br>Lydia Blanchette<br>Corinne Browne<br>Karel Forde-Harrigan<br>Benedict John<br>Marvin Jones<br>Tamara Powell<br>Valene Streete<br>Members of the Marketing, Communications and Public Relations (MCPR) Subcommittee of the 40th Anniversary Planning Committee chaired by Valencia Grant:<br>Brentwood Drigo<br>Sheena Gonsalves<br>Nevine Harvey<br>Aurin Heyliger<br>Steven Neckles<br>Jehu Sedra (Deputy Chair)<br>Members of the Youth Subcommittee of the 40th Anniversary Planning Committee chaired by Leon Bullen:<br>Delishir Archibald<br>Samora Cherebin<br>Kayla Farrell<br>Tessa Marius-Gilbert<br>Bryan Vidal`,

        displayMesh: "Y",
        useMeshButton: "N",
        modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // urlLink1Label: "",
        // urlLink1: '',
        // spriteImageURL: INFO_TAG,
        annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },

    {
        paintingId: "GEN_GEN_P167",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P167.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P168.jpg/info.json`],
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // urlLink1Label: "",
        // urlLink1: '',
        // spriteImageURL: INFO_TAG,
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },

    {
        paintingId: "EST_EST_P170",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_A.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_B.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_C.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_D.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_05.jpg/info.json`],
        headerText: null,
        // bodyText: `<b>Click on the white arrow to view a slideshow of photos related to the Establishment of the ECCB. Scroll down to read the accompanying information and click on the Download #1 & #2  to view the 1983 ECCB Agreement and the 1987 Instrument of Accession by Anguilla</b><br><br><b>Image #1</b><br>Signing of the ECCB Agreement 5 July 1983 : L-R: Hon. Lester Bird - Deputy Prime Minister, Antigua and Barbuda; Hon. Maurice Bishop - Prime Minister, Grenada; Hon. John Osborne - Chief Minister, Montserrat; Mr. Cecil Jacobs - Governor, ECCB; Mr. Vaughn Lewis - Director General - OECS; Hon. Dame Mary Eugenia Charles - Prime Minister, Commonwealth of Dominica; Hon. Kennedy Simmonds - Prime Minister, Saint Christopher (St Kitts) and Nevis; Hon. John Compton - Prime Minister, Saint Lucia; Hon. Milton Cato - Prime Minister, Saint Vincent and the Grenadines. Anguilla became a full member of the ECCB on 1 April 1987.<br><br><b>Image #2</b><br>Mr. Cecil Jacobs (pictured at left), the Managing Director of the East Caribbean Currency Authority (ECCA), was appointed Governor of the Eastern Caribbean Central Bank (ECCB) when it was established on 5 July 1983.<br><br><b>Images #3 & #4</b><br>Members of the First Board of Directors<br><br><b>Image #5</b><br>Members of the First Management Team<br><br><b>Image #6</b><br>Members of the First Monetary Council<br><br><b>Images #7</b><br>As the Bank celebrates its 40th Anniversary, Dr. the Right Excellent and the Right Honourable Sir Kennedy A. Simmonds is the sole surviving signatory of the 1983 ECCB Agreement.  Hon. Kennedy Simmonds, Prime Minister of Saint Christopher (St Kitts) and Nevis, is pictured at left with Hon. Milton Cato, Prime Minister of Saint Vincent and the Grenadines, pictured at right and Hon. John Compton, Prime Minister of Saint Lucia, pictured at centre.<br><br><b>Images #8</b><br>Instrument of Accession by the Government of Anguilla to the Eastern Caribbean Central Bank Agreement, 1983`,
        // bodyText: `<b>Click on the white arrow to view a slideshow of photos related to the Establishment of the ECCB. Scroll down to read the accompanying information and click on the Download #1, #2, & #3  to view the 1983 ECCB Agreement, 1987 Instrument of Accession by Anguilla, and the Consolidated Version of the ECCB Agreement showing the Law as at 31 January 2016.</b><br><br><b>Image #1</b><br>Signing of the ECCB Agreement 5 July 1983 : L-R: Hon. Lester Bird - Deputy Prime Minister, Antigua and Barbuda; Hon. Maurice Bishop - Prime Minister, Grenada; Hon. John Osborne - Chief Minister, Montserrat; Mr. Cecil Jacobs - Governor, ECCB; Mr. Vaughn Lewis - Director General - OECS; Hon. Dame Mary Eugenia Charles - Prime Minister, Commonwealth of Dominica; Hon. Kennedy Simmonds - Prime Minister, Saint Christopher (St Kitts) and Nevis; Hon. John Compton - Prime Minister, Saint Lucia; Hon. Milton Cato - Prime Minister, Saint Vincent and the Grenadines. Anguilla became a full member of the ECCB on 1 April 1987.<br><br><b>Image #2</b><br>Mr. Cecil Jacobs (pictured at left), the Managing Director of the East Caribbean Currency Authority (ECCA), was appointed Governor of the Eastern Caribbean Central Bank (ECCB) when it was established on 5 July 1983.<br><br><b>Images #3 & #4</b><br>Members of the First Board of Directors<br><br><b>Image #5</b><br>Members of the First Management Team<br><br><b>Image #6</b><br>Members of the First Monetary Council<br><br><b>Images #7</b><br>As the Bank celebrates its 40th Anniversary, Dr. the Right Excellent and the Right Honourable Sir Kennedy A. Simmonds is the sole surviving signatory of the 1983 ECCB Agreement.  Hon. Kennedy Simmonds, Prime Minister of Saint Christopher (St Kitts) and Nevis, is pictured at left with Hon. Milton Cato, Prime Minister of Saint Vincent and the Grenadines, pictured at right and Hon. John Compton, Prime Minister of Saint Lucia, pictured at centre.<br><br><b>Images #8</b><br>Instrument of Accession by the Government of Anguilla to the Eastern Caribbean Central Bank Agreement, 1983`,
        bodyText: `<b>Click on the white arrow to view a slideshow of photos related to the Establishment of the ECCB. Scroll down to read the accompanying information and click on the Download #1, #2, & #3  to view the 1983 ECCB Agreement, 1987 Instrument of Accession by Anguilla, and the Consolidated Version of the ECCB Agreement showing the Law as at 31 January 2016.</b><br><br><b>Image #1</b><br>Signing of the ECCB Agreement 5 July 1983 : L-R: Hon. Lester Bird - Deputy Prime Minister, Antigua and Barbuda; Hon. Maurice Bishop - Prime Minister, Grenada; Hon. John Osborne - Chief Minister, Montserrat; Mr. Cecil Jacobs - Governor, ECCB; Mr. Vaughn Lewis - Director General - OECS; Hon. Dame Mary Eugenia Charles - Prime Minister, Commonwealth of Dominica; Hon. Kennedy Simmonds - Premier, Saint Christopher (St Kitts) and Nevis; Hon. John Compton - Prime Minister, Saint Lucia; Hon. Milton Cato - Prime Minister, Saint Vincent and the Grenadines. Anguilla became a full member of the ECCB on 1 April 1987.<br><br><b>Image #2</b><br>Mr. Cecil Jacobs (pictured at left), the Managing Director of the East Caribbean Currency Authority (ECCA), was appointed Governor of the Eastern Caribbean Central Bank (ECCB) when it was established on 5 July 1983.<br><br><b>Images #3 & #4</b><br>Members of the First Board of Directors<br><br><b>Image #5</b><br>Members of the First Management Team<br><br><b>Image #6</b><br>Members of the First Monetary Council<br><br><b>Images #7</b><br>As the Bank celebrates its 40th Anniversary, Dr. the Right Excellent and the Right Honourable Sir Kennedy A. Simmonds is the sole surviving signatory of the 1983 ECCB Agreement.  Hon. Kennedy Simmonds, Premier of Saint Christopher (St Kitts) and Nevis, is pictured at left with Hon. Milton Cato, Prime Minister of Saint Vincent and the Grenadines, pictured at right and Hon. John Compton, Prime Minister of Saint Lucia, pictured at centre.<br><br><b>Images #8</b><br>Instrument of Accession by the Government of Anguilla to the Eastern Caribbean Central Bank Agreement, 1983`,
        displayMesh: "Y",
        useMeshButton: "N",
        // hasCarouselAsParent: 'Y',
        // carouselAnnotationSiblings: ['EST_EST_P170_01', 'EST_EST_P170_02',
        //     'EST_EST_P170_03', 'EST_EST_P170_05'],
        urlLink1Label: "Download #1",
        urlLink1: '/pdf/1983_eccb_agreement.pdf',
        urlLink2Label: "Download #2",
        urlLink2: '/pdf/no_1983_eccb_agreement.pdf',
        urlLink3Label: "Download #3",
        urlLink3: 'https://www.eccb-centralbank.org/viewPDF/documents/2022-05-27-06-12-30-ECCB-Agreement.pdf',
    },
    {
        paintingId: "EST_EST_P170_01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_01.jpg/info.json`,
        headerText: null,
        bodyText: `<b>Click on the yellow arrow to view a slideshow including the 1983 ECCB Agreement, photos and information related to the Establishment of the ECCB.</b><br><br>Signing of the ECCB Agreement 5 July 1983 : L-R: Hon. Lester Bird - Deputy Prime Minister, Antigua and Barbuda; Hon. Maurice Bishop - Prime Minister, Grenada; Hon. John Osborne - Chief Minister, Montserrat; Mr. Cecil Jacobs - Governor, ECCB; Mr. Vaughn Lewis - Director General - OECS; Hon. Dame Mary Eugenia Charles - Prime Minister, Commonwealth of Dominica; Hon. Kennedy Simmonds - Prime Minister, Saint Christopher (St Kitts) and Nevis; Hon. John Compton - Prime Minister, Saint Lucia; Hon. Milton Cato - Prime Minister, Saint Vincent and the Grenadines. Anguilla became a full member of the ECCB on 1 April 1987.`,
        // urlLink1Label: "Download Document",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/1983_eccb_agreement.pdf',
    },
    {
        paintingId: "EST_EST_P170_02",
        videoId: "",
        videoURL: "",
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02.jpg/info.json`,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_A.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_B.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_C.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_02_D.jpg/info.json`],
        headerText: null,
        bodyText: `<b>Click on the yellow arrow to view a slideshow including the 1983 ECCB Agreement, photos and information related to the Establishment of the ECCB.</b><br><br>Mr. Cecil Jacobs (pictured at left), the Managing Director of the East Caribbean Currency Authority (ECCA), was appointed Governor of the Eastern Caribbean Central Bank (ECCB) when it was established on 5 July 1983.`,
    },
    {
        paintingId: "EST_EST_P170_03",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_03.jpg/info.json`,
        headerText: null,
        // bodyText: `Click on the yellow arrow to view the "Instrument of Accession by the Government of Anguilla to the ECCB"<br><br>As the Bank celebrates its 40th Anniversary, Dr. the Right Excellent and the Right Honourable Sir Kennedy A. Simmonds is the sole surviving signatory of the 1983 ECCB Agreement.  Hon. Kennedy Simmonds, Prime Minister of Saint Christopher (St Kitts) and Nevis, is pictured at left with Hon. Milton Cato, Prime Minister of Saint Vincent and the Grenadines, pictured at right and Hon. John Compton, Prime Minister of Saint Lucia, pictured at centre.`,
        bodyText: `<b>Click on the yellow arrow to view a slideshow including the 1983 ECCB Agreement, photos and information related to the Establishment of the ECCB.</b><br><br>As the Bank celebrates its 40th Anniversary, Dr. the Right Excellent and the Right Honourable Sir Kennedy A. Simmonds is the sole surviving signatory of the 1983 ECCB Agreement.  Hon. Kennedy Simmonds, Prime Minister of Saint Christopher (St Kitts) and Nevis, is pictured at left with Hon. Milton Cato, Prime Minister of Saint Vincent and the Grenadines, pictured at right and Hon. John Compton, Prime Minister of Saint Lucia, pictured at centre.`,
    },
    {
        paintingId: "EST_EST_P170_05",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}EST_EST_P170_05.jpg/info.json`,
        headerText: ``,
        bodyText: `<b>Click on the yellow arrow to view a slideshow including the 1983 ECCB Agreement, photos and information related to the Establishment of the ECCB.</b><br><br>Instrument of Accession by the Government of Anguilla to the Eastern Caribbean Central Bank Agreement, 1983`,
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/no_1983_eccb_agreement.pdf',
    },

    // Launches and Firsts Newpapers Clippings Annotation
    {
        paintingId: "LAF_LAF_P172",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_03.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_07.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_04_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_06.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_05.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_04.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_05.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_06.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_07.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_08.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_09.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_10.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P205_11.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_03.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_10_A.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_10_B.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_09.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_11.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_12.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_14.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_13.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_15.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_16.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_17.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P187_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_18.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P187_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P187_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_22.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_20.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_19.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_23.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P217.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_21.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_26.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_25.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_29.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_27.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_28.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P218.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_30.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_32.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_33.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_31.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_34.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_35.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_36.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_36_A.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_37.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_39.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_38.jpg/info.json`
        ],
        headerText: `<h6>Launches and Firsts</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to Launches and Firsts of the ECCB.</b><br>By highlighting several key launches and firsts, this exhibit pays tribute to the innovative spirit that has guided the ECCB from the outset and lives on today.`,
        displayMesh: "Y",
        useMeshButton: "N",
    },


    {
        paintingId: "LAF_LAF_P176",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P176.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P173.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P174.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P175.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P177.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P178.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P179.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P180.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P181.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P182.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P183.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P184.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P185.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P186.jpg/info.json`
        ],
        // headerText: `<h6></h6>`,
        headerText: null,
        bodyText: `<b>Use the Scroll bar on the right of the text below to read all 14 photo descriptions.</b><br><br><b>Photo #1</b><br>Pictured is Mrs. Elaine Dulcie Richardson, Manager, Auditorium and Staff Facilities, with responsibility for social events held at the Bank.<br><br><b>Photo #2</b><br>The late Sir K. Dwight Venner, who served as ECCB Governor from 1989 to 2015, addresses the audience at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006.<br><br><b>Photo #3</b><br>The late Sir Cuthbert Montraville Sebastian GCMG OBE KStJ ED, Governor-General of Saint Christopher (St. Kitts) and Nevis is pictured (at front left) with the Prime Minister of Saint Lucia and Chairman of the ECCB Monetary Council, Dr. the Hon. Kenny Anthony pictured at right.<br><br><b>Photo #4</b><br>The Prime Minister of Saint Christopher (St. Kitts) and Nevis, the Hon. Dr. Denzil L. Douglas is pictured at centre with other officials.<br><br><b>Photo #5</b><br>Pictured third from right is ECCB Governor Sir K. Dwight Venner and pictured third from left is Mrs. Jennifer Nero, ECCB Managing Director.  Pictured with them at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006 are several winners in the ECCB’s Photography Competition.<br><br><b>Photo #6</b><br>Pictured third from right is ECCB Governor Sir K. Dwight Venner and pictured third from left is Mrs. Jennifer Nero, ECCB Managing Director.  Pictured with them at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006 are several winners in the ECCB’s Photography Competition.<br><br><b>Photo #7</b><br>ECCB Governor, Sir K. Dwight Venner makes brief remarks at the opening ceremony of the ECCU Art Exhibit on February 16th, 2006 while Her Excellency Dr. Len Ishmael, Director General of the OECS (pictured at left) and the Prime Minister of Saint Christopher (St. Kitts) and Nevis, the Hon. Dr. Denzil L. Douglas (pictured at right) listen in the background.<br><br><b>Photo #8</b><br>A snapshot of attendees at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006<br><br><b>Photo #9</b><br>A snapshot of the audience at the ECCB Headquarters in Bird Rock, St. Kitts on February 16th, 2006<br><br><b>Photo #10</b><br>A snapshot of attendees at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006<br><br><b>Photo #11</b><br>A snapshot of the audience at the ECCB Headquarters in Bird Rock, St. Kitts on February 16th, 2006<br><br><b>Photo #12</b><br>Flags of ECCB Member Countries wave in the wind with the ECCB Headquarters in the background<br><br><b>Photo #13</b><br>The Prime Minister of Saint Christopher (St. Kitts) and Nevis, the Hon. Dr. Denzil L. Douglas addresses attendees at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006.<br><br><b>Photo #14</b><br>The Prime Minister of Saint Lucia and Chairman of the ECCB Monetary Council, Dr. the Hon. Kenny Anthony delivers remarks at the official Opening Ceremony of the ECCU Art Exhibit on February 16th, 2006.<br>`,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    // {
    //     paintingId: "LAF_LAF_P177",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P177.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P178.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P179.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P180.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P181.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P182.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P183.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P184.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P185.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P186.jpg/info.json`
    //     ],
    //     // headerText: `<h6></h6>`,
    //     headerText: null,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },

    {
        paintingId: "LAF_LAF_P187",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P187.jpg/info.json`,
        // headerText: `<h6>2001 - Communique of the 43rd Meeting of the Monetary Council</h6>`,
        headerText: null,
        bodyText: `<b>Use the Scroll bar on the right of the text below to read the description.</b><br><br>2001 - Communique of the 43rd Meeting of the Monetary Council<br><br>The Communiqué of the 43rd Meeting of the Monetary Council on October 26, 2001 noted that the Eastern Caribbean Securities Market (ECSM) launched on October 19, 2001 had made history as the first fully electronic regional securities market in the Western Hemisphere, that the Regional Government Securities Market (RGSM) was scheduled to come on stream in February 2002, and that a new Bulletin Board Service was introduced on October 16, 2001 to replace the ECCB's brokerage service.<br><br>This Communiqué also noted the decision to lower the discount rate (from 8 to 7 per cent), to stimulate the economy, and the establishment of a Commission on Tax Reform and Administration, to address the weakening fiscal situation.  In the previous Communiqué of July 24, 2001, Council noted its agreement to establish the Commission.<br><br>The Communiqué of the 43rd Meeting of the Monetary Council documents the first ECCB Monetary Council Meeting held after the September 11, 2001 attacks on the USA.`,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    {
        paintingId: "LAF_LAF_P201",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P201_03.jpg/info.json`
        ],
        headerText: `<h6>ECCB Launches Bookmark Series</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },

    // {
    //     paintingId: "LAF_LAF_P203",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_01.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P203_03.jpg/info.json`
    //         ],
    //     headerText: `<h6></h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },

    //  {
    //     paintingId: "LAF_LAF_P204",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204_02.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P204_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_16.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_17.jpg/info.json`
    //         ],
    //     headerText: `<h6>Official Launch<br>of the<br>Eastern Caribbean Securities Market</h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //      urlLink1Label: "Download Document",
    //      urlLink1: '/pdf/LAF_LAF_P204.pdf',
    // },

    // {
    //     paintingId: "LAF_LAF_P205",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_05.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_P172_08.jpg/info.json`
    //
    //         ],
    //     headerText: `<h6>Official Launch<br>of the<br>Eastern Caribbean Securities Market</h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //      urlLink1Label: "Download Document",
    //      urlLink1: '/pdf/LAF_LAF_P205.pdf',
    // },

    {
        // Sir K Dwight Venner, Governor, ECCB
        paintingId: "LAF_LAF_T211",
        videoId: "",
        videoURL: "",
        displayMesh: "N",
        useMeshButton: "N",
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAF_LAF_T211_01', 'LAF_LAF_T211_03', 'LAF_LAF_T211_02'],
    },
    {
        paintingId: "LAF_LAF_T211_01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T211_01.jpg/info.json`,
        // headerText: `<h6>First Remarks to the People of the OECS<br>in the aftermath of September 11th, 2001</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align: center">First Remarks to the People of the OECS in the aftermath of September 11th, 2001</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T211_01.pdf',
    },
    {
        paintingId: "LAF_LAF_T211_03",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T211_03.jpg/info.json`,
        // headerText: `<h6>Feature Address at the Launch of the ECSE<br>on October 19th, 2001</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align: center">Feature Address at the Launch of the ECSE on October 19th, 2001</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T211_03.pdf',
    },
    {
        paintingId: "LAF_LAF_T211_02",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T211_02.jpg/info.json`,
        // headerText: `<h6>Remarks at the Opening Ceremony of the<br>OECS/ECCU Exhibition Centre on February 16th, 2006</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align: center">Remarks at the Opening Ceremony of the OECS/ECCU Exhibition Centre on February 16th, 2006</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T211_02.pdf',
    },


    {
        // TIMOTHY N. J. ANTOINE
        paintingId: "LAF_LAF_T212",
        videoId: "",
        videoURL: "",
        displayMesh: "N",
        useMeshButton: "N",
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAF_LAF_T212_03', 'LAF_LAF_T212_02', 'LAF_LAF_T212_01'],
    },
    {
        paintingId: "LAF_LAF_T212_01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T212_01.jpg/info.json`,
        // headerText: `<h6>Opening Remarks at the Launch of the<br>ECCB’s 40th Anniversary Celebrations<br>on January 19th, 2023</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align:center">Opening Remarks at the Launch of the ECCB’s 40th Anniversary Celebrations<br>on January 19th, 2023</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T212_01.pdf',
    },

    {
        paintingId: "LAF_LAF_T212_02",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T212_02.jpg/info.json`,
        // headerText: `<h6>Statement at the Launch of the<br>Eastern Caribbean Partial Credit Guarantee Corporation (ECPCGC) on<br>October 5th, 2020</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align:center">Statement at the Launch of the Eastern Caribbean Partial Credit Guarantee Corporation (ECPCGC) on October 5th, 2020</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T212_02.pdf',
    },
    {
        paintingId: "LAF_LAF_T212_03",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAF_LAF_T212_03.jpg/info.json`,
        // headerText: `<h6> First Statement to the Citizens and Residents of the<br>ECCU Regarding the COVID-19 Pandemic on<br>April 9th, 2020</h6>`,
        headerText: null,
        bodyText: `<h6 style="text-align:center"> First Statement to the Citizens and Residents of the ECCU Regarding the COVID-19 Pandemic on April 9th, 2020</h6>`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Document",
        urlLink1: '/pdf/LAF_LAF_T212_03.pdf',
    },

    {
        paintingId: "PEC_PEC_P195",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_03.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_04.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_05.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_08.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_07.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_12.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_13.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_14.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_15.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_16.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_20.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_18.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_19.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_21.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_22.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_25.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_26.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_28.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_23.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_27.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_29.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_30.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_33.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_32.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_34.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_31.jpg/info.json`,


            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_35.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_36.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_38.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_41.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_37.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_39.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_PEC_P195_40.jpg/info.json`
        ],
        headerText: `<h6>ECCB’s Public Education & Communications<br>(A 20-Year Retrospective from 1992 to 2012)</h6>`,
        // bodyText: `<b>Click on the white arrow to view a slideshow of photos related to the Public Education & Communications (A 20-Year Retrospective from 1992 to 2012).</b><br><h6 style="text-align: center">ECCB’s Public Education & Communications (A 20-Year Retrospective from 1992 to 2012)</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to Public Education & Communications (A 20-Year Retrospective from 1992 to 2012).</b>`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotation_location_z_offset: 0.08,
        annotationScale: new THREE.Vector3(0.15, 0.15, 0.15),
    },

    {
        paintingId: "PEC_ALM_P199",
        // paintingId: "PEC_ABC_P193", //Old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_05.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_06.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ABC_P193_07.jpg/info.json`
        ],
        headerText: `<h6>The Annual Best Corporate Citizen Award</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Annual Best Corporate Citizen Award.</b><br><br>In 2019, <i>The Bank of the Year Awards</i> replaced <i>The Best Corporate Citizen Awards Among ECCU Commercial Banks.</i>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_SIC_P198",
        // paintingId: "PEC_FIM_P194", //Old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_02.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_04.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_08.jpg/info.json`,


            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_12.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_11.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_13.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_14.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_15.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_16.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_18.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_22.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_23.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_26.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_24.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_19.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_20.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_21.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_25.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_27.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_28.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_29.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_32.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_31.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_33.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_35.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_36.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_37.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_38.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_39.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_40.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_41.jpg/info.json`,
            // `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_34.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_42.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_43.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_44.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_45.jpg/info.json`,

            `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_46.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_FIM_P194_47.jpg/info.json`
        ],

        headerText: `<h6>Financial Information Month (FIM),<br>formerly Financial Literacy Month</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings and images related to Financial Information Month (FIM).</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_AOE_P197",
        // paintingId: "PEC_JAC_P196", // Old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_04.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_09.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_10.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_JAC_P196_11.jpg/info.json`
        ],
        headerText: `<h6>Junior Achievement</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to Junior Achievement.</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_ABC_P193",
        // paintingId: "PEC_AOE_P197", //Old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_12.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_13.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_14.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_15.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_16.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_AOE_P197_18.jpg/info.json`
        ],
        headerText: `<h6>The Annual OECS Essay Competition</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Annual OECS Essay Competition.</b><br><b>Use the Scroll bar on the right of the text below to read the description.</b><br><br>In 2018, <i>The ECCB/RSS-ARU Creative Youth Competition</i> replaced the <i>ECCB-sponsored OECS Essay Competition</i>. The ECCB’s Creative Youth Competition, held in collaboration with the Regional Security System’s Asset Recovery Unit (RSS-ARU), includes various genres of writing/composition and creative expression such as essay writing, poetry, song writing and art. `,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_EYN_P200",
        // paintingId: "PEC_SIC_P198", old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_07.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_08.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_SIC_P198_10.jpg/info.json`
        ],
        headerText: `<h6>The Savings and Investments Course</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Savings and Investments Course.</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_FIM_P194",
        // paintingId: "PEC_ALM_P199", //Old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_05.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_06.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_ALM_P199_07.jpg/info.json`
        ],
        headerText: `<h6>The Sir Arthur Lewis Memorial Lecture</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Sir Arthur Lewis Memorial Lecture.</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "PEC_JAC_P196",
        // paintingId: "PEC_EYN_P200", //old
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_07.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_01.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_02.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_03.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}PEC_EYN_P200_08.jpg/info.json`
        ],
        headerText: `<h6>The Economy and You Newspaper Series</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Economy and You Newspaper Series.</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.25, 0.25, 0.25),
    },

    {
        paintingId: "ASN_ASN_P191",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_04_V02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_09.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_14.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_15.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_12.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P191_13.jpg/info.json`
        ],
        headerText: `<h6>ECCB Anniversaries<br>(Selected Notices)</h6>`,
        // headerText: ``,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to the ECCB Anniversaries (Selected Notices).</b>`,
        displayMesh: "N",
        useMeshButton: "N",
    },

    {
        paintingId: "LSC_LSC_P253",
        videoId: "",
        videoURL: "",
        iframeSource: '',
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LSC_LSC_P253_02', 'LSC_LSC_P253_06', 'LSC_LSC_P253_04',
            'LSC_LSC_P253_01', 'LSC_LSC_P253_05', 'LSC_LSC_P253_03', 'LSC_LSC_P253_07',
            'LSC_LSC_P253_08', 'LSC_LSC_P253_09', 'LSC_LSC_P253_10'],
    },
    {
        paintingId: "LSC_LSC_P253_01",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/1nc_RA3CsmQ',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Grenada Edition</h6>`,
        // bodyText: `Click on the yellow arrows to watch the Lecture Series`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_02",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/EvU_RA0e5VQ',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Anguilla Edition</h6>`,
        // bodyText: `The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.  Click on the yellow arrows to view each lecture in the series.`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_03",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/mU-HbcNm5cM',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Saint Vincent and the Grenadines</h6>`,
        // bodyText: `The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.  Click on the yellow arrows to view each lecture in the series.`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_04",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/xlAnQxuNtlY',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Saint Lucia Edition</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_05",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/pbpF9Y6RoaA',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Montserrat Edition</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_06",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/YYd-iqQtd6U',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Antigua and Barbuda Edition</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_07",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/9ccwiNiMRfM',
        headerText: `<h6>ECCB’s 40th Anniversary Lecture Series<br>Commonwealth of Dominica Edition</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_08",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/KmHqUTHyVzQ',
        headerText: `<h6>The ECCB@40 Youth Symposium<br>October 5th, 2023</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_09",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/3zf3HXhZj58',
        headerText: `<h6>The ECCB@40 Regional Youth Parliament<br>Debate October 6th, 2023</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    {
        paintingId: "LSC_LSC_P253_10",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/gUm_LZR6GLE',
        headerText: `<h6> The ECCB@40 ECCU School Quiz<br>October 12th, 2023</h6>`,
        bodyText: `<b>Click on yellow arrows to view ECCB@40 Anniversary Lecture Series & Youth Activities videos</b><br><br><b>Lecture Series</b><br>The Eastern Caribbean Central Bank held a highly acclaimed Lecture Series in celebration of its 40th Anniversary.<br><br><b>Youth Activities</b><br>In October 2023, the Eastern Caribbean Central Bank executed three successful, high-calibre Youth activities: The ECCB@40 Youth Symposium, The ECCB@40 Regional Youth Parliament Debate and The ECCB@40 ECCU School Quiz, which were all first-time events.`,
    },
    // {
    //     paintingId: "ASN_ASN_P222",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}ASN_ASN_P222.jpg/info.json`,
    //     headerText: `<h6>Message from Dwight Venner</h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },

    // {
    //     paintingId: "VAN_VAN_P189",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_02.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_04.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_06.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_08.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_10.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_12.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_13.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_14.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_15.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_16.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_18.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_19.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_20.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_21.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_22.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_23.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_24.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_25.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_26.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_27.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_28.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_29.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_30.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_31.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_32.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_33.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_34.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_35.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_36.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_37.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_38.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_39.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_40.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_41.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_42.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_43.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_44.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_45.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_46.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_47.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_48.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_49.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_50.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_51.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_52.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_53.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_54.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_55.jpg/info.json`],
    //     headerText: `<h6>Vacancy Announcements<br>(The First 20 Years)</h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },
    {
        paintingId: "VAN_VAN_P189",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_12.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_13.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_14.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_15.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_16.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_18.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_19.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_20.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_21.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_22.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_23.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_25.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_26.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_27.jpg/info.json`,],
        headerText: `<h6>Vacancy Announcements<br>(The First 20 Years)</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to the Vacancy Announcements (The First 20 Years).</b><br><br>Newspaper Clippings from 1984 to 1995`,
        displayMesh: "Y",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },
    {
        paintingId: "VAN_VAN_P189_51",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_28.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_29.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_31.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_32.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_33.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_34.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_35.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_36.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_37.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_38.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_39.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_40.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_41.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_42.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_43.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_44.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_45.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_46.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_47.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_48.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_49.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_50.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_51.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_52.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_53.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_54.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P189_55.jpg/info.json`],
        headerText: `<h6>Vacancy Announcements<br>(The First 20 Years)</h6>`,
        // bodyText: `Newspaper Clippings from 1996 to 2003`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to the Vacancy Announcements (The First 20 Years).</b><br><br>Newspaper Clippings from 1996 to 2003`,
        displayMesh: "Y",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },
    {
        paintingId: "VAN_VAN_P219",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P219.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        annotation_location_vert_offset: -0.12,
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },
    {
        paintingId: "VAN_VAN_P220",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P220.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        annotation_location_vert_offset: -0.12,
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },
    {
        paintingId: "VAN_VAN_P221",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P221.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },

    {
        paintingId: "VAN_VAN_P188",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P188_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}VAN_VAN_P188_02.jpg/info.json`],
        headerText: `<h6>Photos from Library Awareness Day</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
    },

    {
        paintingId: "TBP_TBP_P224",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P224_V02.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P225",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P225.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P226",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P226.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P227",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P227.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P228",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P228.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P229",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P229.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P230",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P230.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P233",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P233.jpg/info.json`,
        headerText: `<h6>Caricom Flag</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P231",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P234",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P234.jpg/info.json`,
        headerText: `<h6>ECCU Flag</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P235",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P235.jpg/info.json`,
        headerText: `<h6>OECS Flag</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P236",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P236.jpg/info.json`,
        headerText: `<h6>OECS Logo</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P232",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P232.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P270",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_004.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_005.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_030.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_041.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_047.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_051.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_052.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_053.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_054.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_056.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_060.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_062.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_063.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_065.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_066.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_069.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_086_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_087.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_088.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_089.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_096.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Big Push.</b><br><br>The Big Push Newspaper Clippings, OECS selects`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P271",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_001.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_002.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_003.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_006.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_007.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_008.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_009.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_010.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_011.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_012.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_013.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_014.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_015.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_016.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_017.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_018.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_019.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_020.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Big Push.</b><br><br>The Big Push Newspaper Clippings, from 1988 to 1998`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P272",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_021.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_022.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_023.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_024.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_025.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_026.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_027.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_028.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_029.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_031.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_032.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_033.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_034.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Big Push.</b><br><br>The Big Push Newspaper Clippings, from 1999 to 2001`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P273",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_035.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_036.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_037.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_038.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_039.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_040.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_042.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_043.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_044.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_045.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_046.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_048.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_049.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_050.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_055.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_057.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_058.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_059.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_061.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_064.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_067.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Big Push.</b><br><br>The Big Push Newspaper Clippings, year 2002`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P274",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_068.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_070.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_071.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_072.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_073.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_074.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_075.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_076.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_077.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_078.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_079.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_080.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_081.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_082.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_083.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_084.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_085.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_086.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_090.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_091.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_092.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_093.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_094.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_095.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_097.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_098.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_099.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P231_100.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to The Big Push.</b><br><br>The Big Push Newspaper Clippings, from 2003 to 2014`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TBP_TBP_P300",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P300_L.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `The Treaty of Basseterre, signed on June 18th, 1981, established the Organisation of Eastern Caribbean States (OECS).`,
        displayMesh: "N",
        useMeshButton: "N",
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/TBP_TBP_P300.pdf',
    },
    {
        paintingId: "TBP_TBP_P301",
        videoId: "",
        videoURL: "",
        // isMediaUsed: 'N',
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TBP_TBP_P301_L.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `The Revised Treaty of Basseterre, signed on June 18th, 2010, established the OECS Economic Union.`,
        displayMesh: "N",
        useMeshButton: "N",
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/TBP_TBP_P301.pdf',
    },

    {
        paintingId: "DVE_DVE_P277",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_12.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_13.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_14.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_15.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_16.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_17.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_18.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_19.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_20.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_21.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_22.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_23.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_25.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_26.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_27.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P277_28.jpg/info.json`],
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of clippings related to Dwight Venner's Exhibit.</b><br><br>Newspaper Clippings, from 1990 to 2012`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "DVE_DVE_P278",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P278.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // urlLink1Label: "",
        // urlLink1: '',
        // spriteImageURL: INFO_TAG,
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "DVE_DVE_P257",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P257.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // urlLink1Label: "",
        // urlLink1: '',
        // spriteImageURL: INFO_TAG,
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },

    {
        paintingId: "DVE_DVE_P279",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P279.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P279_01.jpg/info.json`],
        headerText: `<h6>Timothy Antoine's Speech<br>March 2017</h6>`,
        // bodyText: `Renaming of Building in Honour of Sir Dwight Venner`,
        bodyText: `<b>Click on the white arrow to read the speech</b>`,
        displayMesh: "N",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P279.pdf',
        // spriteImageURL: INFO_TAG,
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },

    {
        paintingId: "DVE_DVE_P276",
        videoId: "",
        videoURL: "",
        displayMesh: "N",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // urlLink1Label: "",
        // urlLink1: '',
        // spriteImageURL: INFO_TAG,
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DVE_DVE_P281', 'DVE_DVE_P282', 'DVE_DVE_P283', 'DVE_DVE_P276_01', 'DVE_DVE_P284', 'DVE_DVE_P285',
            'DVE_DVE_P263', 'DVE_DVE_P265', 'DVE_DVE_P286', 'DVE_DVE_P287', 'DVE_DVE_P266', 'DVE_DVE_P267',
            'DVE_DVE_P288', 'DVE_DVE_P289', 'DVE_DVE_P290', 'DVE_DVE_P297', 'DVE_DVE_P298'],
    },

    {
        paintingId: "DVE_DVE_P276_01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P276.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>28 June 2006</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P276.pdf',
    },
    {
        paintingId: "DVE_DVE_P281",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P281.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>17 October 2000</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P281.pdf',
    },
    {
        paintingId: "DVE_DVE_P282",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P282.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>10 March 2005</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P282.pdf',
    },
    {
        paintingId: "DVE_DVE_P283",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P283.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>16 February 2006</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P283.pdf',
    },
    {
        paintingId: "DVE_DVE_P284",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P284.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>27 July 2006</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P284.pdf',
    },
    {
        paintingId: "DVE_DVE_P285",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P285.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>16 November 2006</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P285.pdf',
    },

    {
        paintingId: "DVE_DVE_P263",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P263.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>18 January 2007</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner<br><br>Listen to <b>Audio 1</b>: 2006 ECCU Economic Review presented on January 18th, 2007`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P263.pdf',
    },
    {
        paintingId: "DVE_DVE_P265",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P265.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>28 January 2010</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner<br><br>Listen to <b>Audio 3</b>: 2009 ECCU Economic Review presented on January 28th, 2010`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P265.pdf',
    },
    {
        paintingId: "DVE_DVE_P286",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P286.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>1 December 2010</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P286.pdf',
    },
    {
        paintingId: "DVE_DVE_P287",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P287.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>15 February 2011</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P287.pdf',
    },

    {
        paintingId: "DVE_DVE_P266",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P266.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>22 July 2011</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner<br><br>Listen to <b>Audio 4</b>: Intervention Antigua - ECCB Governor Speech, 2011`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P266.pdf',
    },
    {
        paintingId: "DVE_DVE_P267",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P267.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>12 August 2013</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner<br><br>Listen to <b>Audio 5</b>: Intervention Anguilla - ECCB Governor Speech, 2013`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P267.pdf',
    },
    {
        paintingId: "DVE_DVE_P288",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P288.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>21 November 2013</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P288.pdf',
    },
    {
        paintingId: "DVE_DVE_P289",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P289.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>20 June 2014</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P289.pdf',
    },
    {
        paintingId: "DVE_DVE_P290",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P290.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>26 June 2014</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P290.pdf',
    },
    {
        paintingId: "DVE_DVE_P297",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P297.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>30 June 2014</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P297.pdf',
    },
    {
        paintingId: "DVE_DVE_P298",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DVE_DVE_P298.jpg/info.json`,
        headerText: `<h6>Sir Dwight Venner's Speech<br>3 July 2014</h6>`,
        bodyText: `Click on yellow arrows to read speeches by Sir Dwight Venner`,
        urlLink1Label: "Download Speech",
        urlLink1: '/pdf/DVE_DVE_P298.pdf',
    },


    {
        paintingId: "TIM_TIM_P291",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P291.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P292",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P292.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P293",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P293.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P294",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P294.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P295",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P295.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P296",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P296.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P303",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P302.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P304.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P305.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P306.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P307.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P308.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P309.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TIM_TIM_P310.jpg/info.json`],
        headerText: `<h6>Plant a Tree Initiative with<br>ECCB Mentorship Schools</h6>`,
        bodyText: `<b>Click on the white arrows to view a slideshow of photos related to Plant a Tree Initiative with ECCB Mentorship Schools</b>`,
        displayMesh: "Y",
        useMeshButton: "N",
    },
    {
        paintingId: "TIM_TIM_P344",
        videoId: "",
        videoURL: "",
        isMediaUsed: 'N',
        headerText: `<h6>1983 - 2023 TIMELINE</h6>`,
        bodyText: `A History of the Eastern Caribbean Central Bank`,
        displayMesh: "N",
        useMeshButton: "N",
        urlLink1Label: "View Timeline",
        urlLink1: '/pdf/TIM_TIM_P344.pdf',
    },

    {
        paintingId: "TAN_TAN_P321",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/fMKIZ-v9rF8',
        headerText: `<h6>The Governor’s Foreword for the<br></br>2018/2019 Annual Report</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "TAN_TAN_P318",
        videoId: "",
        videoURL: "",
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P318.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // urlLink1Label: "Download Report",
        // urlLink1: '/pdf/TAN_TAN_P318.pdf',
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['TAN_TAN_P318_01', 'TAN_TAN_P318_02'],
    },
    {
        paintingId: "TAN_TAN_P318_01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P318.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P318.pdf',
    },
    {
        paintingId: "TAN_TAN_P318_02",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/b_Y9dvVr5oo?si=f9PEBW7aBYo0PN1N',
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },

    {
        paintingId: "TAN_TAN_P319",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P319_P02_V01.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P319.pdf',
    },
    {
        paintingId: "TAN_TAN_P320",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P320_P02_V01.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P320.pdf',
    },
    {
        paintingId: "TAN_TAN_P322",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P322.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P322.pdf',
    },
    {
        paintingId: "TAN_TAN_P323",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P323.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P323.pdf',
    },
    {
        paintingId: "TAN_TAN_P324",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P324.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P324.pdf',
    },
    {
        paintingId: "TAN_TAN_P325",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P325.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Download Report",
        urlLink1: '/pdf/TAN_TAN_P325.pdf',
    },

    {
        paintingId: "TAN_TAN_P338",
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['TAN_TAN_P338_01', 'TAN_TAN_P338_02', 'TAN_TAN_P338_03', 'TAN_TAN_P338_04',
            'TAN_TAN_P338_05', 'TAN_TAN_P338_06', 'TAN_TAN_P338_07', 'TAN_TAN_P338_08'],
    },
    {
        paintingId: "TAN_TAN_P338_01",
        iframeSource: 'https://www.youtube-nocookie.com/embed/81a_JkK-aM0',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB: Developments and Prospects for Anguilla (Streamed live on May 5th, 2022)`,
    },
    {
        paintingId: "TAN_TAN_P338_02",
        iframeSource: 'https://www.youtube-nocookie.com/embed/WT4sHRPDYag?si=j_qcGddYzS9QloKQ',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB: Developments and Prospects for Montserrat (Streamed live on June 9th, 2022)`,
    },
    {
        paintingId: "TAN_TAN_P338_03",
        iframeSource: 'https://www.youtube-nocookie.com/embed/sLVW1ARjiVU?si=XKtuGnh7FC-9-3FQ',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for Saint Lucia (Streamed live on July 27th, 2022)`,
    },
    {
        paintingId: "TAN_TAN_P338_04",
        iframeSource: 'https://www.youtube-nocookie.com/embed/oZwnT5oVLZ4?si=hym3ahSd26C-607i',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for Saint Vincent and the Grenadines (Streamed live on September 15th, 2022)`,
    },
    {
        paintingId: "TAN_TAN_P338_05",
        iframeSource: 'https://www.youtube-nocookie.com/embed/7P2TIwqAnVs?si=gm8V696s0xy1HfOB',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for Grenada (Streamed live on October 26th, 2022)`,
    },
    {
        paintingId: "TAN_TAN_P338_06",
        iframeSource: 'https://www.youtube-nocookie.com/embed/hit5nFMBmZg?si=dtl9r1y4M7hzK5z_',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for Saint Christopher (St. Kitts) and Nevis (Streamed live on March 2nd, 2023)`,
    },
    {
        paintingId: "TAN_TAN_P338_07",
        iframeSource: 'https://www.youtube-nocookie.com/embed/nZwTD0U7SOI?si=Ozkp2FA1MAkFLs1D',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for the Commonwealth of Dominica (Streamed live on May 10th, 2023)`,
    },
    {
        paintingId: "TAN_TAN_P338_08",
        iframeSource: 'https://www.youtube-nocookie.com/embed/2evCMrW8FWU?si=qfcyQwH2pSuMYpxL',
        videoId: "",
        videoURL: "",
        headerText: `<h6></h6>`,
        bodyText: `<b>Click on the yellow arrow to watch the "In Conversation with the Governor of the ECCB" videos</b><br><br>Conversation with the Governor of the ECCB - Developments and Prospects for Antigua and Barbuda (Streamed live on June 15th, 2023)`,
    },

    {
        paintingId: "TAN_TAN_P339",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P339.jpg/info.json`,
        headerText: null,
        bodyText: `In 2018, ECCB Governor Mr. Timothy N.J. Antoine was named Central Bank Governor of the Year for the Caribbean by GlobalMarkets. GlobalMarkets is the newspaper published at the IMF/World Bank, European Bank for Reconstruction & Development, Asian Development Bank and Inter-American Development Bank annual meetings.<br><br>Click on the link  below to access Governor Antoine's latest and archived speeches.`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Read Speeches",
        urlLink1: 'https://www.eccb-centralbank.org/publications/timothy-n-j-antoine',
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },
    {
        paintingId: "TAN_TAN_P340",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P340.jpg/info.json`,
        headerText: null,
        bodyText: `Click on the link  below to access Governor Antoine's latest and archived speeches.`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Read Speeches",
        urlLink1: 'https://www.eccb-centralbank.org/publications/timothy-n-j-antoine',
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },
    {
        paintingId: "TAN_TAN_P334",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P334.jpg/info.json`,`${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P334_02.jpg/info.json`],
        headerText: null,
        bodyText: `<b>Click on the white arrow to view ECCB Star Mantra's images</b><br><br><b>Image #1</b><br>Original Star Mantra<br><br><b>Image #2</b><br>Updated Star Mantra`,
        displayMesh: "N",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        annotation_location_horiz_offset: -0.1,
        annotation_location_vert_offset: -0.06,
    },
    {
        paintingId: "TAN_TAN_P313",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P313.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },
    {
        paintingId: "TAN_TAN_P335",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P335.jpg/info.json`,
        headerText: null,
        bodyText: `Timothy N.J. Antoine is shown in younger days.  The ECCB Governor enjoys music, reading, sports and speaking with youth at church, during visits to ECCB Mentorship Schools and other opportunities that he has to mentor them.`,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },
    {
        paintingId: "TAN_TAN_P336",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P336.jpg/info.json`,
        headerText: null,
        bodyText: null,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },

    {
        paintingId: "TAN_TAN_P342",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P12.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P13.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P14.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P316_P15.jpg/info.json`],
        headerText: `<h6>Board of Directors</h6>`,
        bodyText: `<b>Click on the white arrow to view a slideshow of images related to the "Board of Directors as at March 2002 to 2016". Scroll down to read the accompanying information</b><br><br><b>Image #1</b><br>as at March 21st, 2002<br><br><b>Image #2</b><br>as at March 21st, 2003<br><br><b>Image #3</b><br>as at March 21st, 2004<br><br><b>Image #4</b><br>as at March 21st, 2005<br><br><b>Image #5</b><br>as at March 21st, 2006<br><br><b>Image #6</b><br>as at March 21st, 2007<br><br><b>Image #7</b><br>as at March 21st, 2008<br><br><b>Image #8</b><br>as at March 21st, 2009<br><br><b>Image #9</b><br>as at March 21st, 2010<br><br><b>Image #10</b><br>as at March 21st, 2011<br><br><b>Image #11</b><br>as at March 21st, 2012<br><br><b>Image #12</b><br>as at March 21st, 2013<br><br><b>Image #13</b><br>as at March 21st, 2014<br><br><b>Image #14</b><br>as at March 21st, 2015<br><br><b>Image #15</b><br>as at March 21st, 2016`,
        displayMesh: "Y",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },

    {
        paintingId: "GEN_GEN_P149",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P149.jpg/info.json`,
        headerText: null,
        bodyText: `Click on  the link below for the ECCB@40 Calendar of Events`,
        displayMesh: "N",
        useMeshButton: "N",
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // annotation_location_horiz_offset: 0.2,
        annotation_location_vert_offset: -0.48,
        annotationScale: new THREE.Vector3(0.2, 0.2, 1),
        urlLink1Label : 'ECCB@40 Calendar of Events',
        urlLink1: 'https://www.eccb-centralbank.org/upcoming-events',
    },

    // {
    //     paintingId: "GEN_GEN_P345",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P345.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "N",
    //     useMeshButton: "N",
    //     // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    //     // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    //     annotation_location_horiz_offset: -0.08,
    //     annotation_location_vert_offset: -0.08,
    //     // annotationScale: new THREE.Vector3(0.2, 0.2, 1),
    // },

    {
        paintingId: "TAN_TAN_P343",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P343.jpg/info.json`,
        headerText: null,
        bodyText: `Excerpt from the Communiqué of the 84th Meeting of the ECCB Monetary Council held on February 12th, 2016.`,
        displayMesh: "N",
        useMeshButton: "N",
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        annotationScale: new THREE.Vector3(0.12, 0.12, 1),
        annotation_location_vert_offset: -0.08,
    },
    {
        paintingId: "TAN_TAN_P327",
        videoId: "",
        videoURL: "",
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}TAN_TAN_P327.jpg/info.json`,
        isMediaUsed: 'N',
        headerText: null,
        bodyText: `Click on the link  below to access Governor Antoine's latest and archived speeches.`,
        displayMesh: "Y",
        useMeshButton: "N",
        urlLink1Label: "Read Speeches",
        urlLink1: 'https://www.eccb-centralbank.org/publications/timothy-n-j-antoine',
        // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
        // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
    },


// {
//         paintingId: "",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
//         headerText: null,
//         bodyText: null,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
//         // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
//     },

// {
//         paintingId: "GEN_GEN_P168",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}GEN_GEN_P168.jpg/info.json`,
//         headerText: null,
//         bodyText: null,
//         displayMesh: "N",
//         useMeshButton: "Y",
//         // modelDesktopSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
//         // modelMobileSize: ANNOTATION_MODAL_SIZE.MEDIUM_SIZE,
//         // urlLink1Label: "",
//         // urlLink1: '',
//         // spriteImageURL: INFO_TAG,
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },

    // {
    //     paintingId: "",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h6></h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },

    // {
    //     paintingId: "",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h6></h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    // },
    /* Text Annotations */
];

export {AnnotationsDB};
